
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainLayout from "../layouts/main";
import useTranslation from "next-translate/useTranslation";
import Header from "../components/common/Header";
import Loader from "../components/common/Loader";
import axios from "axios";
import Footer from "../components/common/Footer";
import Banner from "../components/pages/home/Banner";
import About from "../components/pages/home/About";
import HowToBuy from "../components/pages/home/HowToBuy";
import Tokenomics from "../components/pages/home/Tokenomics";
import Ecosystem from "../components/pages/home/Ecosystem";
import Roadmap from "../components/pages/home/Roadmap";
import Faqs from "../components/pages/home/Faq/Faqs";
import PromoBanner from "../components/common/PromoBanner";
export default function Home() {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const faqs = t('home:faqs', {}, { returnObjects: true });
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [apiData, setApiData] = useState({
        current_token_price: "0",
        next_token_price: "0",
        percent_tokens: "0",
        percent_usd: "0",
        stage_name: "Stage 1",
        tokens_left_by_stage: "0",
        tokens_sold: "0",
        total_tokens: "0",
        total_usd: "0",
        usd_raised: "0"
    });
    const getData = async () => {
        return await axios.get('/api/get-data', {
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    useEffect(() => {
        let appLoading = new Promise((resolve, reject) => {
            setTimeout(resolve, 2000, true);
        });
        let apiData = getData().then(data => {
            setApiData(data.data);
        }).catch(() => {
            setApiData({
                current_token_price: "0",
                next_token_price: "0",
                percent_tokens: "0",
                percent_usd: "0",
                stage_name: "Stage 1",
                tokens_left_by_stage: "0",
                tokens_sold: "0",
                total_tokens: "0",
                total_usd: "0",
                usd_raised: "0"
            });
        });
        Promise.all([appLoading, apiData]).then(values => {
            setIsLoading(false);
            setLoaded(true);
        });
    }, []);
    const organizationSchemaData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Pepedollar TOKEN",
        "url": "https://pepedollar.io",
        "about": seo.index_page.description,
        "image": "https://pepedollar.io/logo.png",
        "publisher": {
            "@id": "https://pepedollar.io/#organization"
        },
        "inLanguage": "en-US",
        "copyrightYear": "2024",
        "keywords": seo.index_page.keywords,
        "mainEntity": {
            "@type": "Organization",
            "name": "Pepedollar",
            "alternateName": "PEPD",
            "description": seo.index_page.description,
            "url": "https://pepedollar.io",
            "logo": "https://pepedollar.io/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "email": "info@pepedollar.io",
                "contactType": "Customer Service"
            },
            "sameAs": [
                "https://x.com/PepeDollarETH",
                "https://t.me/pepedollarcommunity"
            ]
        }
    };
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "name": "Pepedollar FAQ - Frequently Asked Questions",
        "mainEntity": faqs.list.map(el => {
            return {
                "@type": "Question",
                "name": el.title,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": el.text.join(' ')
                }
            };
        })
    };
    return (<MainLayout loaded={loaded} title={seo.index_page.title} description={seo.index_page.description} keywords={seo.index_page.keywords} page={'index'} organizationSchemaData={organizationSchemaData} schemaData={schemaData}>
            <div className='shadow'>
                <PromoBanner />
                <Header t={t}/>
                <Banner t={t} apiData={apiData}/>
                <main className='main' style={{ overflowX: 'hidden' }}>
                    <About t={t}/>
                    <HowToBuy t={t}/>
                    <Ecosystem t={t}/>
                    <Roadmap t={t}/>
                    <Tokenomics t={t}/>
                    <Faqs t={t}/>
                </main>
                <Footer t={t}/>

                <Loader isLoading={isLoading} loaded={loaded}/>
            </div>
        </MainLayout>);
}

    async function __Next_Translate__getStaticProps__1989dd4ff3b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989dd4ff3b__ as getStaticProps }
  